const customers = [
  {
    id: 1,
    profileImg: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/customer-avatars/factoryfix.jpg`,
    name: 'Mark Scoptur',
    title: 'VP of Product, FactoryFix',
    quote:
      "PopSQL's collaboration features have been game-changing and have really helped our non-technical users get comfortable with SQL and answer their own questions.",
    link: '/case-studies/factoryfix',
  },
  {
    id: 2,
    profileImg: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/customer-avatars/thescore.jpg`,
    name: 'Cody Clayton',
    title: 'Analytics Lead, theScore',
    quote:
      'With the team now all working remotely, we found it so much easier to use Shared Connections via SSH.',
    link: '',
  },
  {
    id: 3,
    profileImg: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/customer-avatars/scruff.jpg`,
    name: 'Steve Strates',
    title: 'Software Engineer, Scruff',
    quote:
      'Query variables make it easier for people to have access to data that matters without knowing SQL.',
    link: '',
  },
  {
    id: 4,
    profileImg: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/customer-avatars/instacart.jpg`,
    name: 'Nico Bancel',
    title: 'Data Scientist, Instacart',
    quote:
      "I especially love PopSQL's UI. New users don't find it frightening or intimidating.",
    link: '',
  },
  {
    id: 5,
    profileImg: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/customer-avatars/udacity.jpg`,
    name: 'Mike Doll',
    title: 'Head of Data & Analytics, Udacity',
    quote: "There weren't any tools on the market with a comparable solution.",
    link: '/case-studies/udacity',
  },
  {
    id: 6,
    profileImg: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/customer-avatars/branch.jpg`,
    name: 'Fabi Prabhakar',
    title: 'Engineering Director, Branch',
    quote: `I couldn't find another tool that was as pricing friendly and did what we needed the way PopSQL does.`,
    link: '/case-studies/branch',
  },
  {
    id: 7,
    profileImg: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/customer-avatars/darwin.jpg`,
    name: 'Robert Ma',
    title: 'Business Operations, Darwin',
    quote:
      'Shareable queries and real time in-app collaboration are a game changer.',
    link: '/case-studies/darwin',
  },
  {
    id: 8,
    profileImg: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/customer-avatars/jt.jpg`,
    name: 'Rowan Jacobson',
    title: 'VP Analytics, Jobandtalent',
    quote: `PopSQL frees up our own data team's time to work on more strategic insights and projects.`,
    link: '/case-studies/jobandtalent',
  },
  {
    id: 9,
    profileImg: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/homepage/customer-avatars/drop.jpg`,
    name: 'Peter Du',
    title: 'Data Scientist, Drop',
    quote:
      'Looker has a lot of predefined things, but PopSQL gives me more flexibility for writing SQL and visualizing it straight away.',
    link: '',
  },
];

export default customers;
